import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
import { px2rem } from '../utils/helpers/style.js';

var checkboxAttributesNative = {
  color: 'primary',
  background: 'background',
  borders: {
    radius: 'borders.radius'
  },
  label: {
    fontSize: '18px',
    disabled: colors.fogGrey,
    normal: 'text'
  },
  disabled: {
    /**
     * Affects disabled and readOnly checkboxes
     */
    borderColor: colors.fogGrey,
    backgroundColor: colors.lightGrey
  },
  unselected: {
    /**
     * Affects border color of unchecked checkbox
     */
    color: colors.fogGrey
  },
  checkmarkOrientation: 'left'
};
var checkboxThemeNative = _extends({}, checkboxAttributesNative, {
  variants: {
    condensed: {
      label: {
        fontSize: '16px'
      }
    }
  }
});

var checkboxAttributesDarkNative = _extends({}, checkboxAttributesNative, {
  label: {
    fontSize: '18px',
    disabled: colors.emperorGrey,
    normal: 'text'
  },
  unselected: {
    color: colors.octoberGrey
  },
  disabled: {
    borderColor: colors.emperorGrey,
    backgroundColor: 'background'
  }
});

var checkboxDarkThemeNative = _extends({}, checkboxThemeNative, checkboxAttributesDarkNative);
var checkboxAttributesWeb = {
  color: 'primary',
  background: 'background',
  borders: {
    radius: 'borders.radius'
  },
  label: {
    /**
     * Disabled color
     */
    disabled: colors.fogGrey,

    /**
     * Normal color
     */
    normal: 'text',
    fontSize: px2rem(18),
    lineHeight: px2rem(24)
  },
  disabled: {
    /**
     * Affects disabled and readOnly checkboxes
     */
    borderColor: colors.fogGrey,
    backgroundColor: colors.lightGrey
  },
  unselected: {
    /**
     * Same as inactiveColor prop
     * Affects border color of unchecked checkbox
     */
    color: colors.fogGrey
  }
};
var checkboxThemeWeb = _extends({}, checkboxAttributesWeb, {
  variants: {
    condensed: {
      label: {
        fontSize: px2rem(16)
      }
    }
  }
});
var checkboxDarkThemeWeb = _extends({}, checkboxThemeWeb, {
  label: _extends({}, checkboxThemeWeb.label, {
    disabled: colors.emperorGrey
  }),
  disabled: _extends({}, checkboxThemeWeb.disabled, {
    borderColor: colors.emperorGrey,
    backgroundColor: 'background'
  }),
  unselected: _extends({}, checkboxThemeWeb.unselected, {
    color: colors.octoberGrey
  })
});

export { checkboxDarkThemeNative, checkboxDarkThemeWeb, checkboxThemeNative, checkboxThemeWeb };
